<template>
  <div class="cpeso-page">
    <header class="cpeso-header">
      <div>
        <p>Transportacion</p>
        <h1>Configuracion Peso</h1>
      </div>
      <button type="button" @click="nuevo">Nuevo</button>
    </header>

    <section class="cpeso-panel">
      <div class="cpeso-form">
        <label>
          Sucursal
          <select v-model.number="form.sucursal.codigo" @change="cargarRangosSucursal">
            <option :value="null">Seleccione sucursal</option>
            <option v-for="sucursal in sucursales" :key="sucursal.codigo" :value="Number(sucursal.codigo)">
              {{ sucursal.descripcion || sucursal.nombre || ('Sucursal ' + sucursal.codigo) }}
            </option>
          </select>
        </label>

        <label>
          Libra inicial
          <input v-model.number="form.libraInicial" type="number" min="0" step="0.01">
        </label>

        <label>
          Libra final
          <input v-model.number="form.libraFinal" type="number" min="0" step="0.01">
        </label>

        <label>
          Precio por LB
          <input v-model.number="form.precio" type="number" min="0" step="0.01">
        </label>

        <div class="cpeso-actions">
          <button type="button" class="primary" :disabled="guardando" @click="guardar">Guardar</button>
          <button type="button" @click="nuevo">Limpiar</button>
        </div>
      </div>

      <div v-if="mensaje" class="cpeso-message" :class="mensajeTipo">{{ mensaje }}</div>

      <div class="cpeso-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Sucursal</th>
              <th>Libra inicial</th>
              <th>Libra final</th>
              <th>Precio por LB</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="rango in rangos" :key="rango.id">
              <td>{{ nombreSucursal(rango.sucursal) }}</td>
              <td>{{ numero(rango.libraInicial) }}</td>
              <td>{{ numero(rango.libraFinal) }}</td>
              <td>{{ moneda(rango.precio) }}</td>
              <td>
                <button type="button" @click="editar(rango)">Editar</button>
                <button type="button" class="danger" @click="borrar(rango)">Borrar</button>
              </td>
            </tr>
            <tr v-if="rangos.length === 0">
              <td colspan="5" class="empty">No hay rangos configurados para esta sucursal.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ConfiguracionPeso",

  data() {
    return {
      sucursales: [],
      rangos: [],
      guardando: false,
      mensaje: "",
      mensajeTipo: "",
      form: {
        id: null,
        sucursal: { codigo: null },
        libraInicial: 0,
        libraFinal: 0,
        precio: 0,
        borrado: false,
      },
    };
  },

  mounted() {
    this.cargarSucursales();
    this.cargarRangos();
  },

  methods: {
    headers() {
      if (this.$store && this.$store.getters && this.$store.getters.GetheadersAxios) {
        return this.$store.getters.GetheadersAxios;
      }
      return {};
    },
    nuevoForm() {
      return {
        id: null,
        sucursal: { codigo: null },
        libraInicial: 0,
        libraFinal: 0,
        precio: 0,
        borrado: false,
      };
    },
    cargarSucursales() {
      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: this.headers() })
        .then((res) => {
          this.sucursales = Array.isArray(res.data) ? res.data : [];
        });
    },
    cargarRangos() {
      this.$axios.get(this.$hostname + this.$hName + "/configuracionpesoenvio/findall", { headers: this.headers() })
        .then((res) => {
          this.rangos = this.ordenar(Array.isArray(res.data) ? res.data : []);
        });
    },
    cargarRangosSucursal() {
      if (!this.form.sucursal.codigo) {
        this.cargarRangos();
        return;
      }
      this.$axios.get(this.$hostname + this.$hName + "/configuracionpesoenvio/sucursal/" + this.form.sucursal.codigo, { headers: this.headers() })
        .then((res) => {
          this.rangos = this.ordenar(Array.isArray(res.data) ? res.data : []);
        });
    },
    guardar() {
      this.mensaje = "";
      if (!this.form.sucursal.codigo) {
        this.mostrarMensaje("Debe seleccionar la sucursal.", "error");
        return;
      }
      if (Number(this.form.libraFinal || 0) < Number(this.form.libraInicial || 0)) {
        this.mostrarMensaje("La libra final debe ser mayor o igual a la inicial.", "error");
        return;
      }
      if (Number(this.form.precio || 0) <= 0) {
        this.mostrarMensaje("Debe indicar un precio por libra mayor que cero.", "error");
        return;
      }
      this.guardando = true;
      this.$axios.post(this.$hostname + this.$hName + "/configuracionpesoenvio/save", this.form, { headers: this.headers() })
        .then(() => {
          this.mostrarMensaje("Configuracion guardada.", "ok");
          this.cargarRangosSucursal();
          this.nuevo(false);
        })
        .catch((err) => {
          this.mostrarMensaje(this.mensajeError(err), "error");
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    editar(rango) {
      this.form = {
        id: rango.id,
        sucursal: { codigo: Number(rango.sucursal && rango.sucursal.codigo) },
        libraInicial: Number(rango.libraInicial || 0),
        libraFinal: Number(rango.libraFinal || 0),
        precio: Number(rango.precio || 0),
        borrado: false,
      };
    },
    borrar(rango) {
      this.$axios.post(this.$hostname + this.$hName + "/configuracionpesoenvio/borrado", { id: rango.id }, { headers: this.headers() })
        .then(() => {
          this.mostrarMensaje("Rango eliminado.", "ok");
          this.cargarRangosSucursal();
        })
        .catch((err) => {
          this.mostrarMensaje(this.mensajeError(err), "error");
        });
    },
    nuevo(limpiarMensaje) {
      var sucursal = this.form && this.form.sucursal ? this.form.sucursal.codigo : null;
      this.form = this.nuevoForm();
      this.form.sucursal.codigo = sucursal;
      if (limpiarMensaje !== false) {
        this.mensaje = "";
      }
    },
    ordenar(lista) {
      return lista.slice().sort((a, b) => {
        var sa = this.nombreSucursal(a.sucursal);
        var sb = this.nombreSucursal(b.sucursal);
        if (sa !== sb) {
          return sa.localeCompare(sb);
        }
        return Number(a.libraInicial || 0) - Number(b.libraInicial || 0);
      });
    },
    nombreSucursal(sucursal) {
      if (!sucursal) {
        return "";
      }
      return sucursal.descripcion || sucursal.nombre || ("Sucursal " + sucursal.codigo);
    },
    numero(valor) {
      return Number(valor || 0).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    moneda(valor) {
      return "RD$ " + this.numero(valor);
    },
    mostrarMensaje(mensaje, tipo) {
      this.mensaje = mensaje;
      this.mensajeTipo = tipo;
    },
    mensajeError(err) {
      if (err && err.response && err.response.data && err.response.data.message) {
        return err.response.data.message;
      }
      return "No se pudo completar la operacion.";
    },
  },
};
</script>

<style scoped>
.cpeso-page {
  min-height: 100vh;
  padding: 18px;
  background: #f5f1e9;
  color: #000;
}

.cpeso-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1080px;
  margin: 0 auto 8px;
}

.cpeso-header p {
  display: none;
  margin: 0;
  color: #346f99;
}

.cpeso-header h1 {
  margin: 0;
  font-size: 22px;
  color: #000;
}

.cpeso-panel {
  max-width: 1080px;
  margin: 0 auto;
  border: 1px solid #b8ad9c;
  background: #eeeeee;
  padding: 14px;
}

.cpeso-form {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr auto;
  gap: 10px;
  align-items: end;
}

.cpeso-form label {
  display: grid;
  gap: 5px;
  color: #000;
  font-weight: 700;
}

.cpeso-form input,
.cpeso-form select {
  min-height: 36px;
  border: 1px solid #aaa196;
  background: #fff;
  color: #000;
  padding: 0 10px;
}

.cpeso-actions {
  display: flex;
  gap: 8px;
}

button {
  min-height: 36px;
  border: 1px solid #aaa196;
  background: linear-gradient(#fff, #e8e1d7);
  color: #000;
  padding: 0 14px;
  cursor: pointer;
}

button.primary {
  background: #3f749c;
  border-color: #3f749c;
  color: #fff;
}

button.danger {
  border-color: #8f2f3c;
  background: #8f2f3c;
  color: #fff;
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cpeso-message {
  margin-top: 12px;
  padding: 9px 10px;
  border: 1px solid #aaa196;
  background: #fff;
}

.cpeso-message.ok {
  border-color: #3c7d52;
  color: #1e6b37;
}

.cpeso-message.error {
  border-color: #984653;
  color: #9b1f2f;
}

.cpeso-table-wrap {
  margin-top: 14px;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid #c6bdaf;
  padding: 9px;
  text-align: left;
  color: #000;
}

th {
  background: #3f749c;
  color: #fff;
}

td:last-child {
  display: flex;
  gap: 7px;
}

.empty {
  text-align: center;
  color: #555;
}

@media (max-width: 900px) {
  .cpeso-form {
    grid-template-columns: 1fr 1fr;
  }

  .cpeso-actions {
    grid-column: span 2;
  }
}
</style>
